<script setup lang="ts">
import { computed } from 'vue';
import { useDataStore } from '@/stores/useDataStore';
import { useHistorycalStore } from '@/stores/useHistorycalStore';
import { getGroupedDataForList } from '@/functions/historical_data';

const dataStore = useDataStore();
const historyStore = useHistorycalStore()

const groupedData = computed(() => {
  const historicalData = historyStore.historicalData?.results || [];
  return getGroupedDataForList(historicalData);
});
</script>

<template>
  <div v-if="dataStore.selectedCulture?.pbr?.numero_pbr?.startsWith('B')">
    <div v-if="historyStore.historicalData && dataStore.selectedCulture" class="historical-data-wrapper">
      <h3>Liste des données historiques</h3>
      <div class="historical-data-container">
        <div v-if="historyStore.historicalData.results.length === 0" class="no-data">
          {{ $t('noHistoricalData') }} {{ dataStore.selectedCulture.pbr.numero_pbr }}
        </div>
        <div v-for="group in groupedData" class="data-group" :key="group.label">
          <strong>{{ $t(group.label) }}</strong>
          <div v-for="(val, index) in group.values" class="data-value" :key="index">
            <template v-if="group.label === 'co2_flow'">
              {{ val.suffix ? `${val.suffix}: ` : '' }}
              {{ typeof val.displayValue === 'number' ? val.displayValue.toFixed(2) : val.displayValue }} {{ val.unit }}
              <span v-if="val.ratio !== undefined" class="ratio">
                ({{ val.ratio.toFixed(1) }}%)
              </span>
              <span class="time"> - {{ new Date(val.time).toLocaleString() }}</span>
            </template>
            <template v-else>
              {{ val.suffix ? `${val.suffix}: ` : '' }}
              {{ typeof val.displayValue === 'number' ? val.displayValue.toFixed(2) : val.displayValue }} {{ val.unit }}
              <span class="time"> - {{ new Date(val.time).toLocaleString() }}</span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>